
<app-page-not-found *ngIf="!pageFound">
</app-page-not-found>

<ng-container *ngIf="pageFound">
  <!-- Video -->
  <app-embedded-video *ngIf="hasVideos"
    [videoUrl]="videoUrl"
    [query]="videoQuery"
    [attr]="videoAttr">
  </app-embedded-video>

  <!-- Page decoration (banner, introtext, title, blocks) -->
  <app-page-decoration *ngIf="hasPageDecoration"
    [page]="page"
    [type]="'page'">
  </app-page-decoration>

  <div *ngIf="hasBlocksGroups">
    <app-blocks-group *ngFor="let blocksGroup of blocksGroups"
      [blocksGroup]="blocksGroup">
    </app-blocks-group>
  </div>


</ng-container>

